import * as S from './styles';
//Components 
import CancelButton from '../../../components/Button/CancelButton';
import ActionButtonLoad from '../../../components/Button/ActionButtonLoad';
//Icons
import { X } from '@phosphor-icons/react';

interface ILayoutModal {
    title: string;
    subTitle: string;
    children: React.ReactNode;
    setModalClose: () => void;
    submiteModal: any;
    statusLoad: boolean;
    nameSubmit?: string;
    nameCancel?: string;
}
export default function LayoutDefault({
    children,
    setModalClose,
    statusLoad,
    subTitle,
    submiteModal,
    title,
    nameSubmit = 'Salvar',
    nameCancel = 'Cancelar',
}: ILayoutModal) {
    return (
        <S.Container>
            <S.Content>
                <S.Header>
                    <S.infor>
                        <S.Title>
                            {title}
                        </S.Title>
                        <S.SubTitle>
                            {subTitle}
                        </S.SubTitle>
                    </S.infor>
                    <S.Button onClick={setModalClose}>
                        <X size={24} />
                    </S.Button>
                </S.Header>

                <S.Body>
                    {children}
                </S.Body>

                <S.Footer>
                    <div>
                        <CancelButton name={nameCancel} onClick={setModalClose} />
                        <ActionButtonLoad name={nameSubmit} onClick={submiteModal} status={statusLoad} />
                    </div>
                </S.Footer>
            </S.Content>
        </S.Container>
    )
}